import './index.css';
import React from "react";
import ReactDOM from "react-dom/client";
import App from './App.jsx';

ReactDOM.createRoot(document.getElementById("cmciwvv1c009khs5rmi45dmla-root")).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
